import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { useAllowedSections } from '../Routes/customHooks';
import { sectionForPath } from '../constants/planSections';
import NoAccess from './CommonComponents/NoAccess';

export default function PrivateRoute({ children, sections }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;
  const userLoginRole = useSelector((state) => state.AuthReducer.userLoginRole);
  const storedUserData = sessionStorage.getItem('clinic-application-jwt');
  const allowedSections = useAllowedSections();

  useEffect(() => {
    if (storedUserData && !userLoginRole) {
      try {
        const { data } = JSON.parse(storedUserData);
        dispatch({
          type: 'USER_LOGIN_SUCCESS',
          payload: {
            data,
            message: '',
          },
        });
      } catch (err) {
        console.error('Error parsing stored user data:', err);
      }
    }
  }, [storedUserData, userLoginRole, dispatch]);

  if (!storedUserData) {
    if (!currentPath.startsWith('/public')) {
      return <Navigate to="/login" />;
    }
    return children;
  }

  const required = sections || [sectionForPath(currentPath)].filter(Boolean);
  if (required.length && !required.some((s) => allowedSections.includes(s))) {
    return <NoAccess />;
  }

  return children;
}
